module.exports = __webpack_public_path__ + "static/media/snowy-4.474b6da7.svg";